import React from 'react';
import { Container, makeStyles, Modal, Typography } from '@material-ui/core';
import { ReactElement, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';

interface Props {
    title: string;
    images: Array<{
        imageUrl: string;
        description: string;
    }>;
}

const useStyles = makeStyles((theme) => ({
    imageContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        padding: '3rem 0',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        },
    },
    image: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: 'pointer',
        width: 400,
        height: 300,
        margin: '0.5rem 0',
        [theme.breakpoints.down('md')]: {
            width: 300,
            height: 250,
        },
    },
    carouselRoot: {
        display: 'flex',
    },
    carouselContainer: {
        margin: 'auto',
        width: '60vw',
        [`& img`]: {
            height: '90vh',
            [theme.breakpoints.down('md')]: {
                height: '70vh',
            },
            [theme.breakpoints.down('sm')]: {
                height: '50vh',
            },
            [theme.breakpoints.down('xs')]: {
                height: '50vh',
            },
        },
        [theme.breakpoints.down('xs')]: {
            width: '95vw',
        },
    },
}));

export default function GalleryCarousel({ images }: Props): ReactElement {
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const classes = useStyles();
    const selectedItem = images.findIndex(({ imageUrl }) => imageUrl === selectedImageUrl);

    return (
        <>
            <Container className={classes.imageContainer} maxWidth="lg">
                {images.map(({ imageUrl, description }, index) => (
                    <div
                        style={{ backgroundImage: `url("${imageUrl}")` }}
                        title={description}
                        className={classes.image}
                        key={`image-${index}`}
                        onClick={(): void => setSelectedImageUrl(imageUrl)}
                    ></div>
                ))}
            </Container>
            <Modal
                open={Boolean(selectedImageUrl)}
                onClose={(): void => setSelectedImageUrl('')}
                className={classes.carouselRoot}
            >
                <div className={classes.carouselContainer}>
                    <Carousel
                        useKeyboardArrows
                        infiniteLoop
                        autoFocus
                        showThumbs={false}
                        showStatus={false}
                        showIndicators={false}
                        selectedItem={selectedItem}
                    >
                        {images.map(({ imageUrl, description }, index) => (
                            <div key={`carousel-img-${index}`}>
                                <img src={imageUrl} alt={description} />
                                <div className="legend">
                                    <Typography variant="h6">{description}</Typography>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
            </Modal>
        </>
    );
}
